var map = {
	"./platform-amazon_flex.png": 68,
	"./platform-caviar.png": 70,
	"./platform-deliv.png": 65,
	"./platform-dolly.png": 71,
	"./platform-doordash.png": 63,
	"./platform-grubhub.png": 64,
	"./platform-instacart.png": 67,
	"./platform-lyft.png": 66,
	"./platform-postmates.png": 62,
	"./platform-shipt.png": 69,
	"./platform-task-rabbit.png": 107,
	"./platform-uber.png": 33,
	"./platform-wag.png": 108,
	"./platform-wonolo.png": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;